<template lang="pug">
.row.setting_wrapper
  .col-lg-12
    .col-lg-5.col-md-6.pr-lg-60
      h4.mb-5 General
      p.setting-description.small Changes made here will also update your organization's General settings
      .form-group
        label.control-label(for="address-input") Address
        textarea#address-input.form-control.mb-10(
          v-model="address"
          rows="4"
        )
      .form-group
        label.control-label(for="tax-id-input") Tax ID
        AppTooltipIcon.ml-5(
          text-type="lighter"
          message="Used to identify your organization"
          placement="auto right"
        )
        input#tax-id-input.form-control(
          v-model="taxNumber"
          placeholder="Enter tax ID"
        )
      h4.mt-30 Invoice logo
      p.setting-description.small This is a logo used specifically for invoices, and will apply to all invoices made
      .form-group
        label.control-label(for="logo-input") Logo
        AppImageUploader#logo-input.my-10(
          :file-url="invoiceLogo"
          :loading="false"
          :placeholder="false"
          @start-uploading="onStartUploading"
        )
        p.setting-description.small File size limit: 1 MB

      h4.mt-30 Payment
      ValidationProvider(
        v-slot="{ errors }"
        rules="greaterThanZeroOrNull"
      )
        .form-group(:class="{ 'has-error': errors[0] }")
          label.control-label(for="tax-rate-input") Tax Rate
          AppTooltipIcon.text-lighter.ml-5(
            text-type="lighter"
            message="The percentage of tax you want applied to the invoice total"
            placement="auto right"
          )
          .input-group.col-lg-6
            input#tax-rate-input.form-control(
              v-model="taxRate"
              placeholder="Ex. 7"
              maxlength="6"
              min="0"
              max="100"
              step="0.01"
            )
            span.input-group-addon %
          AppDialogError(:errors="errors")

      .form-group
        label.control-label(for="notes-input")
          | Notes (Shown on invoices)
        AppTooltipIcon.ml-5(
          text-type="lighter"
          message="Shown as a message on invoices when client specific notes are not set"
          placement="auto right"
        )
        textarea#notes-input.form-control(
          v-model="invoiceNotes"
          rows="3"
          placeholder="Enter notes to client"
        )
      ValidationProvider(
        v-slot="{ errors }"
        rules="required|numeric"
      )
        .form-group(:class="{ 'has-error': errors[0] }")
          label.control-label(for="terms-input") Net Terms*
          AppTooltipIcon.text-lighter.ml-5(
            text-type="lighter"
            message="Amount of days the invoice must be paid once created"
            placement="auto right"
          )
          .input-group.col-lg-6
            input#terms-input.form-control(v-model="netTerms")
            span.input-group-addon days
          AppDialogError(:errors="errors")
      h4.mt-30 Payment button
      .form-group
        label.control-label(for="paypal-email-input") PayPal Email
        input#paypal-email-input.form-control(
          v-model="paypalEmail"
          placeholder="Enter your business's PayPal email address"
        )
        .hint Easily accept payments from clients with PayPal
    .col-lg-7.col-md-6.pl-lg-20
      AutoInvoicingSettingsForm(:start-week-on="startWeekOn")
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { mapFormFields } from '~/utils/form_utils';

import AutoInvoicingSettingsForm from './AutoInvoicingSettingsForm.vue';
import { SET_LOADING, UPDATE_ORGANIZATION } from '~/stores/InvoicesSettingsStore/types';

export default {
  name: 'InvoicesSettingsForm',
  components: {
    AutoInvoicingSettingsForm,
  },
  data: () => ({
    defaultSelect2Options: {
      allowClear: false,
      multiple: false,
      width: '100%',
      minimumResultsForSearch: -1,
    },
    uploadedPreview: null,
  }),
  computed: {
    ...mapFormFields(
      'organization',
      {
        address: 'address',
        invoiceLogo: 'invoice_logo',
        taxNumber: 'tax_number',
        taxRate: 'tax_1',
        invoiceNotes: 'invoice_notes',
        netTerms: 'net_terms',
        paypalEmail: 'paypal_email',
      },
      UPDATE_ORGANIZATION,
    ),
    ...mapState({
      organization: (state) => state.organization,
    }),
    startWeekOn() {
      return this.organization.start_week_on;
    },
  },
  methods: {
    ...mapActions(['updateState', 'uploadFile']),
    ...mapMutations({
      setLoading: SET_LOADING,
    }),
    onStartUploading(file) {
      this.setLoading(true);
      this.uploadFile(file)
        .then((response) => {
          this.invoiceLogo = response.get_url;
        })
        .catch((e) => {
          this.setLoading(false);
          this.$appMessage(e.message);
        });
    },
  },
};
</script>
